import React from 'react';
import Marker from '../../../../Map/Marker/Marker';
import RadarMarker from '../../../../Map/Marker/RadarMarker';

class StopMarkers extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.activeStop !== nextProps.activeStop ||
      this.props.radarPos !== nextProps.radarPos
    );
  }

  render() {
    const {
      tourStops,
      activeStop,
      radarPos,
      changeStop,
      switchMapView,
      tourId,
    } = this.props;

    return tourStops.map(stop => {
      stop.callback = this.openPopup;
      stop.activeStop = activeStop;
      stop.radarPos = radarPos;
      return stop.panoNorthView && activeStop === stop.order ? (
        <RadarMarker key={stop.id} data={stop} highlight />
      ) : (
        <Marker
          key={stop.id}
          className="tour-stop-marker-fixed"
          data={stop}
          showPopup
          highlight={stop.order === activeStop}
          switchView={switchMapView}
          changeStop={changeStop}
          tourId={tourId}
        />
      );
    });
  }
}

export default StopMarkers;
